import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VincForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { canEdit } = useAuth();
  const isEdit = Boolean(id);
  const [loading, setLoading] = useState(isEdit);
  const [siparisler, setSiparisler] = useState([]);
const [openSections, setOpenSections] = useState({
    genel: true,
    tarihler: false,
    kaldirma: false,
    celik: false,
    elektrik: false,
    dosyalar: false
  });
  const [uploading, setUploading] = useState(false);

  const [formData, setFormData] = useState({
    siparis_id: '',
    seri_no: '',
    proje_sorumlusu: '',
    sozlesme_numarasi: '',
    sozlesme_tarihi: '',
    termin_tarihi: '',
    imalat_tarihi: '',
    sevk_tarihi: '',
    vinc_tipi: 'Çift Kiriş Gezer Köprülü Vinç',
    kapasite: '',
    aciklik: '',
    yukseklik: '',
    derinlik: '',
    direk_aralari: '',
    kaldirma_tipi: '',
    donam: '',
    ana_reduksiyon: '',
    kaldirma_motor_kw: '',
    kaldirma_motor_devir: '',
    kaldirma_hizi: '',
    kaldirma_hizi_2: '',
    halat_cap: '',
    halat_tipi: '',
    halat_boyu: '',
    tambur_cap: '',
    tambur_boyu: '',
    kanca: '',
    calisma_profili: '',
    calisma_aksi: '',
    calisma_rayi: '',
    yurutme_reduktoru: '',
    yurutme_reduktoru_adeti: '',
    kedi_yurutme_hizi: '',
    kedi_yurutme_hizi_2: '',
    teker_cap_kedi: '',
    teker_tipi_kedi: '',
    kaldirma_makinasi_rengi: '',
    alt_ust_sac_olcu: '',
    alt_ust_sac_kalinlik: '',
    alt_ust_sac_adet: '',
    alt_ust_sac_agirlik: '',
    yan_sac_olcu: '',
    yan_sac_kalinlik: '',
    yan_sac_adet: '',
    yan_sac_agirlik: '',
    kopru_rayi_olcu: '',
    kopru_rayi_adet: '',
    kopru_rayi_agirlik: '',
    ic_dikme_olcu: '',
    ic_dikme_adet: '',
    ic_dikme_agirlik: '',
    kosebent_olcu: '',
    kosebent_adet: '',
    kosebent_agirlik: '',
    yurume_yolu_ray_profili: '',
    yurume_yolu_adet: '',
    yurume_yolu_agirlik: '',
    yurume_yolu_rayi: '',
    yurume_yolu_rayi_adet: '',
    yurume_yolu_rayi_agirlik: '',
    yurume_yolu_rayalti: '',
    yurume_yolu_direkleri: '',
    ankraj: '',
    sac_olcusu: '',
    sac_olcusu_not: '',
    baslik_profili: '',
    teker_cap_kopru: '',
    teker_tipi_kopru: '',
    kopru_calisma_rayi: '',
    kopru_yurutme_reduktoru: '',
    kopru_yurutme_reduktor_adet: '',
    kopru_yurutme_hizi: '',
    kopru_yurutme_hizi_2: '',
    celik_konstruksiyon_rengi: '',
    pano_ebadi: '',
    pano_konumu: '',
    kaldirma_motor_detay: '',
    kedi_yurutme_motor_detay: '',
    kopru_yurutme_motor_detay: '',
    kumanda_tipi: '',
    uzaktan_kumanda_model: '',
    hareket_sayisi: '',
    sesli_isikli_ikaz: '',
    tur_sivici: '',
    limit_sivici: '',
    asiri_yuk_sivici: '',
    kopru_enerji_uzunluk: '',
    kopru_enerji_sistem: '',
    hol_enerji_uzunluk: '',
    hol_enerji_sistem: '',
    notlar: '',
    dosyalar: []
  });

  useEffect(() => {
    fetchSiparisler();
    if (isEdit) {
      fetchVinc();
    }
  }, [id]);

  const fetchSiparisler = async () => {
    try {
      const response = await axios.get(`${API}/siparisler`);
      setSiparisler(response.data);
    } catch (error) {
      console.error('Siparişler yüklenirken hata:', error);
    } finally {
      if (!isEdit) setLoading(false);
    }
  };

  const fetchVinc = async () => {
    try {
      const response = await axios.get(`${API}/vincler/${id}`);
      const data = response.data;
      ['sozlesme_tarihi', 'termin_tarihi', 'imalat_tarihi', 'sevk_tarihi'].forEach(field => {
        if (data[field]) {
          data[field] = new Date(data[field]).toISOString().split('T')[0];
        }
      });
      setFormData(data);
    } catch (error) {
      console.error('Vinç yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const submitData = { ...formData };
      ['sozlesme_tarihi', 'termin_tarihi', 'imalat_tarihi', 'sevk_tarihi'].forEach(field => {
        if (submitData[field]) {
          submitData[field] = submitData[field] + 'T12:00:00.000Z';
        }
      });

      if (isEdit) {
        await axios.put(`${API}/vincler/${id}`, submitData);
      } else {
        await axios.post(`${API}/vincler`, submitData);
      }
      navigate('/vincler');
    } catch (error) {
      console.error('Vinç kaydedilirken hata:', error);
      alert('Vinç kaydedilemedi');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleSection = (section) => {
    setOpenSections({ ...openSections, [section]: !openSections[section] });
  };

  // Dosya yükleme
  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    setUploading(true);
    const newDosyalar = [...(formData.dosyalar || [])];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formDataFile = new FormData();
      formDataFile.append('file', file);

      try {
        const response = await axios.post(`${API}/upload`, formDataFile, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        newDosyalar.push({
          dosya_adi: file.name,
          aciklama: '',
          dosya_yolu: response.data.url,
          yukleme_tarihi: new Date().toISOString()
        });
      } catch (error) {
        console.error('Dosya yüklenirken hata:', error);
        alert(`${file.name} yüklenemedi`);
      }
    }

    setFormData({ ...formData, dosyalar: newDosyalar });
    setUploading(false);
    e.target.value = '';
  };

  const handleDosyaAciklamaChange = (index, value) => {
    const newDosyalar = [...formData.dosyalar];
    newDosyalar[index].aciklama = value;
    setFormData({ ...formData, dosyalar: newDosyalar });
  };

const handleDosyaSil = async (index) => {
    if (window.confirm('Bu dosyayı silmek istediğinize emin misiniz?')) {
      const dosya = formData.dosyalar[index];
      
      // Sunucudan dosyayı sil
      if (dosya.dosya_yolu) {
        try {
          const filename = dosya.dosya_yolu.split('/uploads/').pop();
          await axios.delete(`${API}/upload/${filename}`);
        } catch (error) {
          console.error('Dosya sunucudan silinirken hata:', error);
        }
      }
      
      const newDosyalar = formData.dosyalar.filter((_, i) => i !== index);
      setFormData({ ...formData, dosyalar: newDosyalar });
    }
  };

  // Input field renderer - inline olarak kullanılacak
  const renderField = (label, name, type = 'text', options = null) => (
    <div className="form-group">
      <label className="form-label">{label}</label>
      {options ? (
        <select className="form-select" name={name} value={formData[name]} onChange={handleChange} disabled={!canEdit()}>
          {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
        </select>
      ) : (
        <input 
          type={type} 
          className="form-input" 
          name={name} 
          value={formData[name] || ''} 
          onChange={handleChange} 
          disabled={!canEdit()} 
        />
      )}
    </div>
  );

  // Section renderer
  const renderSection = (title, name, children) => (
    <div className="card" style={{marginBottom: '16px'}}>
      <div 
        onClick={() => toggleSection(name)}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          padding: '16px',
          background: '#f8fafc',
          borderRadius: '8px',
          marginBottom: openSections[name] ? '16px' : 0
        }}
      >
        <h3 style={{margin: 0, fontSize: '18px', fontWeight: 600}}>{title}</h3>
        <span style={{fontSize: '20px'}}>{openSections[name] ? '▼' : '▶'}</span>
      </div>
      {openSections[name] && <div>{children}</div>}
    </div>
  );

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">{isEdit ? 'Vinç Düzenle' : 'Yeni Vinç'}</h1>
        <p className="page-subtitle">Teknik özellikleri giriniz</p>
      </div>

      <form onSubmit={handleSubmit}>
        {renderSection("GENEL BİLGİLER", "genel", (
          <>
            <div className="form-grid">
              {renderField("Sipariş *", "siparis_id", "text", [
                {value: '', label: 'Sipariş seçiniz'},
                ...siparisler.map(s => ({value: s.id, label: s.siparis_no}))
              ])}
              {renderField("Vinç Seri No *", "seri_no")}
            </div>
            <div className="form-grid">
              {renderField("Sözleşme Numarası", "sozlesme_numarasi")}
              {renderField("Proje Sorumlusu", "proje_sorumlusu")}
            </div>
            <div className="form-grid">
              {renderField("Vinç Tipi", "vinc_tipi", "text", [
                {value: 'Arabalı Vinç', label: 'Arabalı Vinç'},
                {value: 'Monoray Vinç', label: 'Monoray Vinç'},
                {value: 'Sabit Vinç', label: 'Sabit Vinç'},
                {value: 'Çift Kiriş Gezer Köprülü Vinç', label: 'Çift Kiriş Gezer Köprülü Vinç'},
                {value: 'Tek Kiriş Gezer Köprülü Vinç', label: 'Tek Kiriş Gezer Köprülü Vinç'},
                {value: 'Portal Vinç', label: 'Portal Vinç'}
              ])}
              {renderField("Kapasite", "kapasite")}
            </div>
            <div className="form-grid">
              {renderField("Açıklık", "aciklik")}
              {renderField("Yükseklik", "yukseklik")}
              {renderField("Derinlik", "derinlik")}
            </div>
            <div className="form-group">
              {renderField("Direk Araları", "direk_aralari")}
            </div>
          </>
        ))}

        {renderSection("TARİHLER", "tarihler", (
          <>
            <div className="form-grid">
              {renderField("Sözleşme Tarihi", "sozlesme_tarihi", "date")}
              {renderField("Termin Tarihi", "termin_tarihi", "date")}
            </div>
            <div className="form-grid">
              {renderField("İmalat Tarihi", "imalat_tarihi", "date")}
              {renderField("Sevk Tarihi", "sevk_tarihi", "date")}
            </div>
          </>
        ))}

        {renderSection("KALDIRMA GRUBU", "kaldirma", (
          <>
            <h4 style={{marginTop: 0, color: '#3b82f6'}}>Temel Bilgiler</h4>
            <div className="form-grid">
              {renderField("Kaldırma Tipi", "kaldirma_tipi")}
              {renderField("Donam", "donam")}
              {renderField("Ana Redüksiyon", "ana_reduksiyon")}
            </div>
            <div className="form-grid">
              {renderField("Kaldırma Motor Gücü (kW)", "kaldirma_motor_kw")}
              {renderField("Motor Devir", "kaldirma_motor_devir")}
            </div>
            <div className="form-grid">
              {renderField("Kaldırma Hızı 1", "kaldirma_hizi")}
              {renderField("Kaldırma Hızı 2", "kaldirma_hizi_2")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Halat Bilgileri</h4>
            <div className="form-grid">
              {renderField("Halat Çapı", "halat_cap")}
              {renderField("Halat Tipi", "halat_tipi")}
              {renderField("Halat Boyu", "halat_boyu")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Tambur</h4>
            <div className="form-grid">
              {renderField("Tambur Çapı", "tambur_cap")}
              {renderField("Tambur Boyu", "tambur_boyu")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Kanca ve Çalışma</h4>
            <div className="form-grid">
              {renderField("Kanca", "kanca")}
              {renderField("Çalışma Profili", "calisma_profili")}
            </div>
            <div className="form-grid">
              {renderField("Çalışma Aksı", "calisma_aksi")}
              {renderField("Çalışma Rayı", "calisma_rayi")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Kedi Yürütme</h4>
            <div className="form-grid">
              {renderField("Yürütme Redüktörü", "yurutme_reduktoru")}
              {renderField("Redüktör Adeti", "yurutme_reduktoru_adeti")}
            </div>
            <div className="form-grid">
              {renderField("Kedi Yürütme Hızı 1", "kedi_yurutme_hizi")}
              {renderField("Kedi Yürütme Hızı 2", "kedi_yurutme_hizi_2")}
            </div>
            <div className="form-grid">
              {renderField("Teker Çapı (Kedi)", "teker_cap_kedi")}
              {renderField("Teker Tipi (Kedi)", "teker_tipi_kedi")}
            </div>
            <div className="form-group">
              {renderField("Kaldırma Makinası Rengi", "kaldirma_makinasi_rengi")}
            </div>
          </>
        ))}

        {renderSection("ÇELİK KONSTRÜKSİYON", "celik", (
          <>
            <h4 style={{marginTop: 0, color: '#3b82f6'}}>Alt/Üst Saclar</h4>
            <div className="form-grid">
              {renderField("Ölçü", "alt_ust_sac_olcu")}
              {renderField("Kalınlık", "alt_ust_sac_kalinlik")}
              {renderField("Adet", "alt_ust_sac_adet")}
              {renderField("Ağırlık", "alt_ust_sac_agirlik")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Yan Saclar</h4>
            <div className="form-grid">
              {renderField("Ölçü", "yan_sac_olcu")}
              {renderField("Kalınlık", "yan_sac_kalinlik")}
              {renderField("Adet", "yan_sac_adet")}
              {renderField("Ağırlık", "yan_sac_agirlik")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Köprü Üzeri Rayı</h4>
            <div className="form-grid">
              {renderField("Ölçü", "kopru_rayi_olcu")}
              {renderField("Adet", "kopru_rayi_adet")}
              {renderField("Ağırlık", "kopru_rayi_agirlik")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>İç Dikme Sacı</h4>
            <div className="form-grid">
              {renderField("Ölçü", "ic_dikme_olcu")}
              {renderField("Adet", "ic_dikme_adet")}
              {renderField("Ağırlık", "ic_dikme_agirlik")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Köşebent</h4>
            <div className="form-grid">
              {renderField("Ölçü", "kosebent_olcu")}
              {renderField("Adet", "kosebent_adet")}
              {renderField("Ağırlık", "kosebent_agirlik")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Yürüme Yolu</h4>
            <div className="form-grid">
              {renderField("Ray Profili", "yurume_yolu_ray_profili")}
              {renderField("Adet", "yurume_yolu_adet")}
              {renderField("Ağırlık", "yurume_yolu_agirlik")}
            </div>
            <div className="form-grid">
              {renderField("Rayı", "yurume_yolu_rayi")}
              {renderField("Ray Adet", "yurume_yolu_rayi_adet")}
              {renderField("Ray Ağırlık", "yurume_yolu_rayi_agirlik")}
            </div>
            <div className="form-grid">
              {renderField("Rayaltı", "yurume_yolu_rayalti")}
              {renderField("Direkleri", "yurume_yolu_direkleri")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Diğer</h4>
            <div className="form-grid">
              {renderField("Ankraj", "ankraj")}
              {renderField("Sac Ölçüsü", "sac_olcusu")}
            </div>
            <div className="form-group">
              {renderField("Sac Ölçüsü Not", "sac_olcusu_not")}
            </div>
            <div className="form-group">
              {renderField("Başlık Profili", "baslik_profili")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Köprü Yürütme</h4>
            <div className="form-grid">
              {renderField("Teker Çapı (Köprü)", "teker_cap_kopru")}
              {renderField("Teker Tipi (Köprü)", "teker_tipi_kopru")}
            </div>
            <div className="form-grid">
              {renderField("Çalışma Rayı", "kopru_calisma_rayi")}
              {renderField("Yürütme Redüktörü", "kopru_yurutme_reduktoru")}
            </div>
            <div className="form-grid">
              {renderField("Redüktör Adet", "kopru_yurutme_reduktor_adet")}
              {renderField("Yürütme Hızı 1", "kopru_yurutme_hizi")}
            </div>
            <div className="form-grid">
              {renderField("Yürütme Hızı 2", "kopru_yurutme_hizi_2")}
              {renderField("Çelik Konstrüksiyon Rengi", "celik_konstruksiyon_rengi")}
            </div>
          </>
        ))}

        {renderSection("ELEKTRİK", "elektrik", (
          <>
            <h4 style={{marginTop: 0, color: '#3b82f6'}}>Pano</h4>
            <div className="form-grid">
              {renderField("Pano Ebadı", "pano_ebadi")}
              {renderField("Pano Konumu", "pano_konumu")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Motorlar</h4>
            <div className="form-group">
              {renderField("Kaldırma Motor Detay", "kaldirma_motor_detay")}
            </div>
            <div className="form-group">
              {renderField("Kedi Yürütme Motor Detay", "kedi_yurutme_motor_detay")}
            </div>
            <div className="form-group">
              {renderField("Köprü Yürütme Motor Detay", "kopru_yurutme_motor_detay")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Kumanda ve Sistemler</h4>
            <div className="form-grid">
              {renderField("Kumanda Tipi", "kumanda_tipi")}
              {renderField("Uzaktan Kumanda Model", "uzaktan_kumanda_model")}
            </div>
            <div className="form-grid">
              {renderField("Hareket Sayısı", "hareket_sayisi")}
              {renderField("Sesli/Işıklı İkaz", "sesli_isikli_ikaz")}
            </div>
            <div className="form-grid">
              {renderField("Tur Sıvıcı", "tur_sivici")}
              {renderField("Limit Sıvıcı", "limit_sivici")}
            </div>
            <div className="form-group">
              {renderField("Aşırı Yük Sıvıcı", "asiri_yuk_sivici")}
            </div>

            <h4 style={{marginTop: '24px', color: '#3b82f6'}}>Enerji Sistemleri</h4>
            <div className="form-grid">
              {renderField("Köprü Enerji Uzunluk", "kopru_enerji_uzunluk")}
              {renderField("Köprü Enerji Sistem", "kopru_enerji_sistem")}
            </div>
            <div className="form-grid">
              {renderField("Hol Enerji Uzunluk", "hol_enerji_uzunluk")}
              {renderField("Hol Enerji Sistem", "hol_enerji_sistem")}
            </div>
          </>
        ))}

{renderSection("DOSYALAR", "dosyalar", (
          <>
            <div style={{ marginBottom: '16px' }}>
              <input
                type="file"
                multiple
                onChange={handleFileUpload}
                disabled={uploading || !canEdit()}
                style={{ display: 'none' }}
                id="vinc-dosya-input"
              />
              <label htmlFor="vinc-dosya-input" className="btn btn-secondary" style={{ cursor: canEdit() ? 'pointer' : 'not-allowed' }}>
                {uploading ? '⏳ Yükleniyor...' : '📁 Dosya Ekle'}
              </label>
              <span style={{ marginLeft: '12px', color: '#666', fontSize: '14px' }}>
                Birden fazla dosya seçebilirsiniz
              </span>
            </div>

            {formData.dosyalar && formData.dosyalar.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Dosya Adı</th>
                    <th>Açıklama</th>
                    <th>Yükleme Tarihi</th>
                    <th>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.dosyalar.map((dosya, index) => (
                    <tr key={index}>
                      <td>
                        <a href={encodeURI(dosya.dosya_yolu)} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6' }}>
                          📄 {dosya.dosya_adi}
                        </a>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-input"
                          value={dosya.aciklama || ''}
                          onChange={(e) => handleDosyaAciklamaChange(index, e.target.value)}
                          placeholder="Açıklama ekle..."
                          disabled={!canEdit()}
                          style={{ margin: 0 }}
                        />
                      </td>
                      <td style={{ fontSize: '14px', color: '#666' }}>
                        {dosya.yukleme_tarihi ? new Date(dosya.yukleme_tarihi).toLocaleDateString('tr-TR') : '-'}
                      </td>
                      <td>
                        {canEdit() && (
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleDosyaSil(index)}
                            style={{ padding: '4px 8px', fontSize: '12px' }}
                          >
                            🗑️ Sil
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ color: '#666', textAlign: 'center', padding: '20px' }}>
                Henüz dosya eklenmemiş
              </p>
            )}
          </>
        ))}

        <div className="card">
          <h3>NOTLAR</h3>
          <div className="form-group">
            <label className="form-label">Ek Notlar</label>
            <textarea
              name="notlar"
              className="form-textarea"
              value={formData.notlar || ''}
              onChange={handleChange}
              rows={5}
              disabled={!canEdit()}
            />
          </div>
        </div>

        {canEdit() && (
          <div className="form-actions">
            <button type="submit" className="btn btn-primary">{isEdit ? 'Güncelle' : 'Kaydet'}</button>
            <button type="button" className="btn btn-secondary" onClick={() => navigate('/vincler')}>İptal</button>
          </div>
        )}
      </form>
    </div>
  );
};

export default VincForm;
